import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ModalService } from '@app/core/modal.service';
import { ModalResult, ModalPublicProperties, EndpointSecretModalComponent as ModalComponent } from './endpoint-secret-modal.component';

@Injectable({ providedIn: 'root' })
export class EndpointSecretModalService {
  constructor(private modalService: ModalService) {}

  open(properties?: ModalPublicProperties, options?: NgbModalOptions) {
    return this.modalService.open<ModalResult>(ModalComponent, properties, options);
  }
}
